import store from "@/redux/store";
import axios from "axios";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from "@/config/serverApiConfig";
import errorHandler from "./errorHandler";
import successHandler from "./successHandler";
import storePersist from "@/redux/storePersist";
import { logout } from "@/auth";
import * as actionTypes from "@/redux/auth/types";
const state = store.getState();

const publicRoutes = [
  "/login-user",
  "/forgetPassword",
  "/logout-user",
  "/car",
  "/models",
  "/user/verify-token",
  "/user/password-update",
];

const isPublicRoute = (url) => {
  const cleanedUrl = url?.replace(/^https?:\/\/[^/]+/, "");
  return publicRoutes.some((route) => cleanedUrl.startsWith(route));
};

const headersInstance = {
  [ACCESS_TOKEN_NAME]: `Bearer ${storePersist.get(ACCESS_TOKEN_NAME)}`,
};

const getAuthHeader = () => {
  const token = storePersist.get(ACCESS_TOKEN_NAME);
  return token ? { [ACCESS_TOKEN_NAME]: `Bearer ${token}` } : {};
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("ERROR OF INTERCEPTOR: ", error);
    if (error?.response?.status === 401) {
      logout();
      store?.dispatch({
        type: actionTypes.LOGOUT_SUCCESS,
      });
      window.location.href = "/login";
    }
    if (error?.response?.status === 405) {
      logout();
      store?.dispatch({
        type: actionTypes.LOGOUT_SUCCESS,
      });
      window.location.href = "/waiting-page";
    }
    console.log("ERROR OF ERROR-HANDLER: ", errorHandler(error));
    return errorHandler(error);
  }
);

const request = {
  post: async (entityUrl, jsonData, showSuccessNotification, option = {}) => {
    try {
      const config = {
        headers: isPublicRoute(entityUrl) ? {} : getAuthHeader(),
        ...option,
      };
      const response = await axiosInstance.post(entityUrl, jsonData, config);
      return successHandler(response, showSuccessNotification);
    } catch (error) {
      console.log(error);
      console.error("Request Error:", error.response?.data || error.message);
      return errorHandler(error);
    }
  },
  get: async (entityUrl, showSuccessNotification, params) => {
    try {
      const config = {
        headers: isPublicRoute(entityUrl) ? {} : getAuthHeader(),
        params,
      };
      const response = await axiosInstance.get(entityUrl, config);
      return successHandler(response, showSuccessNotification);
    } catch (error) {
      console.log(error);
      return errorHandler(error);
    }
  },
  patch: async (entityUrl, jsonData, showSuccessNotification) => {
    const config = {
      headers: isPublicRoute(entityUrl) ? {} : getAuthHeader(),
      ...option,
    };
    try {
      const response = await axiosInstance.patch(entityUrl, jsonData, config);
      return successHandler(response, showSuccessNotification);
    } catch (error) {
      return errorHandler(error);
    }
  },
  put: async (entityUrl, jsonData, showSuccessNotification, option = {}) => {
    try {
      const config = {
        headers: isPublicRoute(entityUrl) ? {} : getAuthHeader(),
        ...option,
      };
      const response = await axiosInstance.put(entityUrl, jsonData, config);
      return successHandler(response, showSuccessNotification);
    } catch (error) {
      console.log(error);
      console.error("Request Error:", error.response?.data || error.message);
      return errorHandler(error);
    }
  },
};
export default request;
